import {useCallback, useContext, useMemo} from 'react'

import Context from '@s-ui/react-context'

import {useTranslateForm} from './useTranslateForm.js'

const NUMERIC_INPUT_PROPS = {inputMode: 'numeric'}

export const useFormUserContactConfiguration = ({currentUser}) => {
  const {domain} = useContext(Context)
  const {translateForm} = useTranslateForm()

  const {defaultInitFieldValue, formErrorTypes, formFieldIds, formUserContactFormConfig} = domain
    .get('config')
    .get('form')
  const {email, name, phone, postalCode} = formFieldIds

  const formUserContactConfiguration = useMemo(() => {
    const form = structuredClone(formUserContactFormConfig.form)
    translateForm(form)

    return {form}
  }, [formUserContactFormConfig, translateForm])

  const {email: userEmail, name: userName, phone: userPhone, zipCode: userZipCode} = currentUser ?? {}

  const initFields = useMemo(
    () => ({
      [email]: userEmail ?? defaultInitFieldValue,
      [name]: userName ?? defaultInitFieldValue,
      [phone]: userPhone ?? defaultInitFieldValue,
      [postalCode]: userZipCode ?? defaultInitFieldValue
    }),
    [defaultInitFieldValue, email, name, phone, postalCode, userEmail, userName, userPhone, userZipCode]
  )

  const SUIComponentsConfig = useCallback(
    ({id}) => {
      const props = {
        [phone]: NUMERIC_INPUT_PROPS,
        [postalCode]: NUMERIC_INPUT_PROPS
      }
      return props[id]
    },
    [phone, postalCode]
  )

  return {
    formUserContactConfiguration,
    formErrorTypes,
    formFieldIds,
    initFields,
    SUIComponentsConfig
  }
}
